import { useRef } from 'react';
import Player from 'components/3catinfo/Player';
import clsx from 'clsx';
import styles from '../cosminutaminut.module.scss';

const Video = (props) => {
    const { id } = props;
    const playerRef = useRef();

    const stylesMedia = clsx({
        [styles.media]: true,
        [styles.mediaVideo]: true
    });

    return (
        <div className={stylesMedia} data-testid='cos-minutaminut-media-video'>
            <Player id={id} estils='noticia' ref={playerRef} playerVideoTagId={`video-noticia-${id}`} />
        </div>
    );
};

export default Video;
